__turbopack_context__.v({
  "subtleBounce": "Csn2Wa_subtleBounce",
  "subtlePulse": "Csn2Wa_subtlePulse",
  "supportBadge": "Csn2Wa_supportBadge",
  "supportButton": "Csn2Wa_supportButton",
  "supportButtonGift": "Csn2Wa_supportButtonGift",
  "supportButtonHeart": "Csn2Wa_supportButtonHeart",
  "supportButtonIcon": "Csn2Wa_supportButtonIcon",
  "supportButtonMediaQuery": "Csn2Wa_supportButtonMediaQuery",
  "supportButtonPremium": "Csn2Wa_supportButtonPremium",
  "supportButtonPrimary": "Csn2Wa_supportButtonPrimary",
  "supportButtonRoyal": "Csn2Wa_supportButtonRoyal",
  "supportButtonSparkle": "Csn2Wa_supportButtonSparkle",
  "supportButtonText": "Csn2Wa_supportButtonText",
  "supportChip": "Csn2Wa_supportChip",
  "supportHoverCard": "Csn2Wa_supportHoverCard",
});
